import { z } from 'zod'

// Человек компании-заказчика. Роль member|admin (customer-admin правит команду),
// статус active|revoked (мягкий отзыв доступа).
export const AccountRoleSchema = z.enum(['member', 'admin'])
export type AccountRole = z.infer<typeof AccountRoleSchema>

export const AccountStatusSchema = z.enum(['active', 'revoked'])
export type AccountStatus = z.infer<typeof AccountStatusSchema>

export const CustomerAccountSchema = z.object({
  id: z.string(),
  company_id: z.string(),
  full_name: z.string(),
  login: z.string(),
  job_title: z.string().optional(),
  role: AccountRoleSchema,
  status: AccountStatusSchema,
  project_access: z.array(z.string()),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type CustomerAccount = z.infer<typeof CustomerAccountSchema>

// Строка списка людей компании: счётчик выданных сделок вместо массива.
export const CustomerAccountListItemSchema = z.object({
  id: z.string(),
  company_id: z.string(),
  full_name: z.string(),
  login: z.string(),
  job_title: z.string().optional(),
  role: AccountRoleSchema,
  status: AccountStatusSchema,
  project_access_count: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type CustomerAccountListItem = z.infer<typeof CustomerAccountListItemSchema>

// Проект, выданный человеку (name/slug пусты, если проект удалён).
export const ProjectAccessItemSchema = z.object({
  project_id: z.string(),
  name: z.string().optional(),
  slug: z.string().optional(),
})
export type ProjectAccessItem = z.infer<typeof ProjectAccessItemSchema>
